import Description from '@material-ui/icons/Description';

import List from './List';

export default {
  list: List,
  icon: Description,
};
